module.exports = __webpack_public_path__ + "img/y-title.d4c66a3a.png";